import { SecurityDomainDto } from '@repo/shared/dtos/SecurityDomainDto';
import { getSecurityDomain } from '../../utils/auth';
import { useQuery } from '@tanstack/react-query';

const SECURITY_DOMAIN_QUERY_KEY = 'security-domain';

export function useSecurityDomain(domain: SecurityDomainDto) {
  const { data, error } = useQuery({
    queryKey: [SECURITY_DOMAIN_QUERY_KEY, domain],
    queryFn: async (): Promise<{ isAllowed: boolean }> => {
      const response = await getSecurityDomain(domain);
      return response.json();
    },
  });

  return { isAllowed: error ? false : data?.isAllowed };
}
